import { render, staticRenderFns } from "./channelListAll.vue?vue&type=template&id=9961bf5e&"
import script from "./channelListAll.vue?vue&type=script&lang=js&"
export * from "./channelListAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports